import { Component, OnInit } from "@angular/core";
import { ChainMaintenanceFilterComponent } from "./chain-maintenance-filter/chain-maintenance-filter.component";
import { DialogService, LanguageService, HelperService } from "src/app/services";
import { MAINTENANCE_CHAIN_FOLDERNAME } from "src/app/utils/constant";
import { ChainMaintenanceService } from "./chain-maintenance.service";
import { environment } from "src/environments/environment";
import { of as observableOf, Subscription } from "rxjs";
import { MediaObserver } from "@angular/flex-layout";
import { catchError, finalize } from "rxjs/operators";
import { requestChain } from "src/app/model/requests";
import { MatDialogRef } from "@angular/material/dialog";
import * as _ from "lodash";

@Component({
  selector: 'esc-chain-maintenance',
  templateUrl: './chain-maintenance.component.html',
  styleUrls: ['./chain-maintenance.component.scss']
})
export class ChainMaintenanceComponent implements OnInit {
  public loading = {
    init: false,
    detail: false,
    more: false,
    export: false,
    import: false,
    error: false,
    detailError: false
  };
  private listSub: Subscription;
  private detailSub: Subscription;

  public folderName = MAINTENANCE_CHAIN_FOLDERNAME
  public listData = [];
  public detailData;
  public columns = ["code", "description", "is_active"];
  public excelCols = ["CHAIN CODE", "CHAIN NAME", "CHAIN TYPE CODE", "CHAIN TYPE NAME",  "STATUS"];
  public detailKeys = ["code", "description", "is_active"];
  private currentFilters;
  private previousFilters;
  public listLength = 0;
  public mode;
  public modifying: Boolean = false;
  public deselect: Boolean = false;
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});

  constructor(
    public media: MediaObserver,
    private chainMntSvc: ChainMaintenanceService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    private helper: HelperService
  ) {}

  ngOnInit() {
    this.currentFilters = _.cloneDeep(requestChain);
    this.getListData();
  }

  ngOnDestroy() {
    if (this.listSub && !this.listSub.closed) {
      this.listSub.unsubscribe();
    }
  }
  

  getListData() {
    if (this.listSub && !this.listSub.closed) {
      this.listSub.unsubscribe();
    }
    if (this.loading.init == true) {
      return;
    }
    this.loading.error = false;
    if (this.listData.length == 0) {
      this.loading.init = true;
    } else {
      this.loading.more = true;
    }
    this.listSub = this.chainMntSvc.getList(this.currentFilters).pipe(
      finalize(() => {
        this.loading.init = false;
        this.loading.more = false;
        return observableOf(null);
      }),
      catchError(err => {
        if (this.listData.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.currentFilters.web_filter.offset -= this.currentFilters.web_filter.limit;
        }
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.error = true;
          this.listData = [];
          this.listLength = 0;
          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, "value") && _.toLower(res.value) == _.toLower("Success")) {
          this.listData = this.listData.concat(res.data);
          this.listLength = _.toNumber(_.get(res, "count"));
        }
      });
  }
  
  download(ev) {
    let dialogRef = this.dialogService.loading();
    this.listSub = this.chainMntSvc.genericMaintenanceDownload(this.currentFilters).pipe(
      finalize(() => {
        this.loading.init = false;
        this.loading.more = false;
        return observableOf(null);
      }),
      catchError((err) => {
        if (this.listData.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.currentFilters.web_filter.offset -= this.currentFilters.web_filter.limit;
        }
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.error = true;
          this.listData = [];
          this.listLength = 0;
          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, 'value') && (_.toLower(res.value) == _.toLower("Success"))) {
          this.helper.openDownloadMenu(res.data);
          dialogRef.close();
        }
      });
  }
  
  getMore(event) {
    if (this.loading.more || this.loading.init || this.listData.length >= this.listLength) {
      return;
    }
    if (event) {
      this.currentFilters.web_filter.offset += this.currentFilters.web_filter.limit;
      this.getListData();
    }
  }

  getDetail(data) {
    if(data) {
      let temp = this.listData.filter(e => {
        return e.id == data.id;
      })
      this.detailData = _.clone(temp[0]);
      this.deselect = false;
    }
  }

  addNew(event) {
    this.closeDetail(null);
    this.modifying = true;
    this.mode = "Add";
  }

  edit(event) {
    this.modifying = true;
  }

  searchBy(keyword) {
    this.currentFilters.web_filter.keyword = _.clone(keyword);
    this.refresh(true);
  }

  openFilter(ev) {
    let dialogRef: MatDialogRef<ChainMaintenanceFilterComponent>;
    dialogRef = this.dialogService.openDialog(ChainMaintenanceFilterComponent, {
      width: '500px',
      autoFocus: false,
      disableClose: false,
      data: _.get(this, 'previousFilters') || _.get(this, 'currentFilters')
    });
    dialogRef.afterClosed().subscribe((selectedFilters) => {
      if(selectedFilters) {
        this.previousFilters = _.cloneDeep(selectedFilters);

        this.currentFilters.web_filter.chain_type_ids =  [_.get(selectedFilters, 'chain_type.id') || 0];
        this.currentFilters.web_filter.status =  _.get(selectedFilters, 'status.code');
        this.refresh(null);
      }
    })
  }

  saving(event) {
    this.loading.detail = true;
    if(_.has(event[0], 'code')) {
      let obj = _.get(event, '[0]');
      this.detailData = _.clone(obj);
    } 
    else if(!event) {
      this.loading.detail = false;
    }
  }

  closeDetail(event) {
    this.detailData = null;
    this.deselect = true;
  }

  closeForm(event) {
    this.modifying = false;
    this.mode = null;
    if(event) {
      this.refresh(event);
    }
  }

  refresh(event) {
    if (!event) {
      this.closeDetail(null);
    }
    this.listData = [];
    this.listLength = 0;
    this.currentFilters.web_filter.offset = _.clone(requestChain.web_filter.offset);
    this.getListData();
  }
}